<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'UserList' }" class="nav-link">Użytkownicy</router-link></h2><div class="page-title__buttons"><router-link :to="{ name: 'UserCreate' }" class="btn btn-default"><span>Dodaj użytkownika</span><svg-icon name="plus"/></router-link></div></page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="deletedItem" class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
			<div v-if="error" class="alert alert-danger">{{ error }}</div>

			<div v-if="!loading">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover table-clickable table-search">
					<thead>
					<tr>
						<th>Imię</th>
						<th>Nazwisko</th>
						<th>E-mail</th>
						<th></th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in items">
						<td><router-link v-if="item" :to="{name: 'UserShow', params: { id: item['id'] }}" class="link">{{ item['name'] }}</router-link></td>
						<td><router-link v-if="item" :to="{name: 'UserShow', params: { id: item['id'] }}" class="link">{{ item['surname'] }}</router-link></td>
						<td><router-link v-if="item" :to="{name: 'UserShow', params: { id: item['id'] }}" class="link">{{ item['email'] }}</router-link></td>
						<td>
							<router-link :to="{name: 'UserUpdate', params: { id: item['id'] }}" class="btn btn-icon" v-b-tooltip.hover.bottom title="Edytuj użytkownika">
								<svg-icon name="edit"/>
							</router-link>
						</td>
					</tr>
					</tbody>
				</table>
				</div>  
				<pagination :changePage="changePage" :currentPage="currentPage" :pagination="pagination"></pagination>
			</div>
		</div>
	</b-container>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import sort from '../../utils/order';

  export default {
    computed: mapGetters({
		deletedItem: 'user/del/deleted',
		error: 'user/list/error',
		items: 'user/list/items',
		loading: 'user/list/loading',
		currentPage: 'user/list/currentPage',
    	pagination: 'user/list/pagination',
		order: 'user/list/order',
		filter: 'user/list/filter'
    }),
    methods: mapActions({
      	getOrder: function(column) {
			return sort(this.order, column);
		},
		...mapActions({
			getItems: 'user/list/getItems',
			setOrder: 'user/list/order',
			changePage: 'user/list/changePage'
		})
    }),
    created () {
      this.$store.dispatch('user/list/getItems')
    }
  }
</script>


// WEBPACK FOOTER //
// List.vue?017e80fa